import React, { useState, useEffect } from "react"
import Header from "../../../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import {
  Box,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Tooltip,
  Checkbox,
  FormControl,
  FormHelperText,
  FormControlLabel,
  useStepContext,
} from "@mui/material"
import ImprimirIcon from "../../../../../assets/iconos/Impresion.ico"
import DetalleImpresion from "../../../../Zonas/components/DetalleImpresion"

import Alert from "@mui/material/Alert"
import Swal from "sweetalert2"
import { useQuery, useQueryClient, useMutation, dataTagSymbol } from "@tanstack/react-query"
import CustomAutoComplete from "../../../../SolicitudDeIngreso/components/CustomAutoComplete"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import BackIcon from "../../../../../components/BackIcon"
import GrabarIcon from "../../../../../assets/iconos/Grabar.ico"
import fetchwrapper from "../../../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../../../components/CustomBackdrop"
import CustomTextFieldReadable from "../../../../../components/CustomTextFieldReadable"
import CustomTextField from "../../../../../components/CustomTextField"
import AsociacionPdf from "../../../components/AsociacionPdf"
//  crear funciona como un mantenedor normal y devuelve a la pagina de opciones
//  estilo del formulario
//  campos de creacion
const ClienteBox = styled(Box)({
  gridArea: "ClienteBox",
})
const ClienteNombreBox = styled(Box)({
  gridArea: "ClienteNombreBox",
})
const ContactoBox = styled(Box)({
  gridArea: "ContactoBox",
})
const BodegaBox = styled(Box)({
  gridArea: "BodegaBox",
})
const ArticuloBox = styled(Box)({
  gridArea: "ArticuloBox",
})
const ArticuloDescriBox = styled(Box)({
  gridArea: "ArticuloDescriBox",
})
const EmbalajeBox = styled(Box)({
  gridArea: "EmbalajeBox",
})
const EmbalajeDescriBox = styled(Box)({
  gridArea: "EmbalajeDescriBox",
})
// Contenedor de campos de creacion
const Container = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteNombreBox ClienteNombreBox ClienteNombreBox ClienteNombreBox ClienteNombreBox ClienteNombreBox"
    "ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox"
    "ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloDescriBox ArticuloDescriBox ArticuloDescriBox ArticuloDescriBox ArticuloDescriBox ArticuloDescriBox "
    "EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeDescriBox EmbalajeDescriBox EmbalajeDescriBox EmbalajeDescriBox EmbalajeDescriBox EmbalajeDescriBox "
  `,
  gap: "8px",
  alignItems: "center",

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(6, 1fr)",
    gridTemplateAreas: `
      "ClienteBox ClienteBox ClienteBox ClienteNombreBox ClienteNombreBox ClienteNombreBox "
      "ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox"
      "BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox"
      "ArticuloBox ArticuloBox ArticuloBox ArticuloDescriBox ArticuloDescriBox ArticuloDescriBox"
      "EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeDescriBox EmbalajeDescriBox EmbalajeDescriBox"
    `,
  },
}))
const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))
const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const EditarAsociacion = () => {
  const { id } = useParams()
  const location = useLocation()
  console.log(location)
  const codigoCliente = location.state.clicodigo
  const nombreCliente = location.state.clinombre
  const contactoCliente = location.state.condescri
  const articuloCodigo = location.state.artcodigo
  const articuloNombre = location.state.artdescri
  const embCodigo = location.state.embcodigo
  const embDescri = location.state.embdescripcion
  const codigoBodega = location.state.bodcodigo
  const ciacodigo = location.state.ciacodigo
  const datosActuales = {
    clicodigo: codigoCliente,
    clinombre: nombreCliente,
    condescri: contactoCliente,
    artcodigo: articuloCodigo,
    artdescri: articuloNombre,
    embcodigo: embCodigo,
    embdescripcion: embDescri,
    ciacodigo,
  }
  console.log("datosActuales", datosActuales)
  const [openModal, setOpenModal] = useState(false)
  const [infoGenerada, setInfoGenerada] = useState([])
  const [clienteNombre, setClienteNombre] = useState(nombreCliente)
  const [artNombre, setArticuloNombre] = useState(articuloNombre)
  const [embalajeDescri, setEmbalajeDescri] = useState(embDescri)
  const { mutateAsync: updateAsociacion, isPending: isUpdatingAsociacion } = useUpdateAsociacion()
  const handleOpenModal = () => {
    const datos = [datosActuales]
    console.log("datos", datos)
    setInfoGenerada(datos) // Asigna los datos de la tabla al estado
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    navigate(`/home/dashboard/AsociacionProdAgencias/buscar`)
  }

  const navigate = useNavigate()
  function useUpdateAsociacion() {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (asociacion) => {
        // send api update request here
        // send api update request here
        const options = {
          method: "PUT",
          body: JSON.stringify(asociacion),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json", options.body)
        let response = await fetchwrapper(`/AsociacionProdAgencia/updateAsociacion`, options)

        response = response.json()
        console.log(response)
        return response
      },
      // client side optimistic update
      onMutate: (newAsociacion) => {
        console.log(newAsociacion, "onmutate")
        queryClient.setQueryData(["AsociacionProdAgencia", id], (prevAsociacion) => ({
          ...newAsociacion,
        }))
      },
      // onSettled: () => queryClient.invalidateQueries({ queryKey: ['bancoDePreguntas'] }), //refetch bancoDePreguntas after mutation, disabled for demo
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      const asociacion = {
        clicodigo: codigoCliente,
        clinombre: clienteNombre,
        artcodigo: articuloCodigo,
        artdescri: artNombre,
        embcodigo: embCodigo,
        embdescripcion: embalajeDescri,
      }
      console.log("json enviado para update", asociacion)
      await updateAsociacion(asociacion)
      Swal.fire({
        icon: "success",
        title: "Operación exitosa",
        text: "Se pudo editar la Asociacion",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/home/dashboard/AsociacionProdAgencias/buscar") // Navegar a la ruta especificada
        }
      })
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "No se pudo editar la Asociacion",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/home/dashboard/AsociacionProdAgencias/buscar") // Navega de vuelta cuando se cierre el SweetAlert
      })
    }
  }
  const handleClienteNombreChange = (event) => {
    setClienteNombre(event.target.value)
  }
  useEffect(() => {
    setClienteNombre(clienteNombre)
    console.log(clienteNombre)
  }, [clienteNombre])
  const handleArticuloNombreChange = (event) => {
    setArticuloNombre(event.target.value)
  }
  useEffect(() => {
    setArticuloNombre(artNombre)
    console.log(artNombre)
  }, [artNombre])
  const handleEmbalajeDescriChange = (event) => {
    setEmbalajeDescri(event.target.value)
  }
  useEffect(() => {
    setEmbalajeDescri(embalajeDescri)
    console.log(embalajeDescri)
  }, [embalajeDescri])
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Asociacion de Productos a Agencias</b>
        </div>
        <Box className={StyledRoot}>
          <form onSubmit={handleSubmit}>
            <Tooltip title="Grabar">
              <Button type="submit" color="primary" sx={{ marginTop: "15px" }}>
                <img src={GrabarIcon} alt="Grabar" style={{ width: "40px" }} />
              </Button>
            </Tooltip>
            <Tooltip title="Imprimir">
              <Button color="primary" onClick={handleOpenModal} sx={{ marginTop: "15px" }}>
                <img src={ImprimirIcon} alt="Imprimir" style={{ width: "30px" }} />
              </Button>
            </Tooltip>
            <DetalleImpresion
              open={openModal}
              handleClose={handleCloseModal}
              infoGenerada={[datosActuales]}
              nombrePdf={"AsociacionProductoAgencia"}
              PdfComponent={AsociacionPdf}
            />
            <Container>
              <ClienteBox>
                <CustomTextFieldReadable label="Cliente" value={codigoCliente}></CustomTextFieldReadable>
              </ClienteBox>
              <ClienteNombreBox>
                <CustomTextField
                  label="Nombre"
                  value={clienteNombre}
                  onChange={handleClienteNombreChange}
                ></CustomTextField>
              </ClienteNombreBox>
              <ContactoBox>
                <CustomTextFieldReadable label="Contacto" value={contactoCliente}></CustomTextFieldReadable>
              </ContactoBox>
              <BodegaBox>
                <CustomTextFieldReadable label="Bodega" value={codigoBodega}></CustomTextFieldReadable>
              </BodegaBox>
              <ArticuloBox>
                <CustomTextFieldReadable label="Articulo" value={articuloCodigo}></CustomTextFieldReadable>
              </ArticuloBox>
              <ArticuloDescriBox>
                <CustomTextField
                  label="Nombre de Articulo"
                  value={artNombre}
                  onChange={handleArticuloNombreChange}
                ></CustomTextField>
              </ArticuloDescriBox>
              <EmbalajeBox>
                <CustomTextFieldReadable label="Embalaje" value={embCodigo}></CustomTextFieldReadable>
              </EmbalajeBox>
              <EmbalajeDescriBox>
                <CustomTextField
                  label="Descripcion Embalaje"
                  value={embalajeDescri}
                  onChange={handleEmbalajeDescriChange}
                ></CustomTextField>
              </EmbalajeDescriBox>
            </Container>
          </form>
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default EditarAsociacion
